import _ from 'lodash'

export function loadStorage (state, fields, storage, storageKey) {
  try {
    const storageJson = storage.getItem(storageKey)
    const storageObject = storageJson ? JSON.parse(storageJson) : null
    if (storageObject) {
      for (const field of fields) {
        if (field in storageObject) {
          _.set(state, field, storageObject[field])
        }
      }
    }
  } catch (e) {
    console.error(e)
  }
}

export function saveStorage (state, fields, storage, storageKey) {
  try {
    const storageObject = { }
    for (const field of fields) {
      const fieldValue = _.get(state, field)
      if (fieldValue !== undefined) {
        storageObject[field] = fieldValue
      }
    }
    storage.setItem(storageKey, JSON.stringify(storageObject))
  } catch (e) {
    console.error(e)
  }
}

export function isAncestorElementOf (ancestor, child) {
  if (!ancestor) return false
  for (let ele = child; ele; ele = ele.parentElement) {
    if (ele === ancestor) {
      return true
    }
  }
  return false
}

const compatibleEventsMap = {
  focus: 'onfocusout',
  blur: 'onblur'
  // TODO:
}

export function addEventListener (event, callback, options) {
  window.addEventListener ? window.addEventListener(event, callback, options) : window.attachEvent(compatibleEventsMap[event], callback)
}

export function removeEventListener (event, callback, options) {
  window.removeEventListener ? window.removeEventListener(event, callback, options) : window.detachEvent(compatibleEventsMap[event], callback)
}

export const [onActiveElementChanged, offActiveElementChanged] = (function () {
  let initialized = false
  let activeElement = null
  const callbacks = new Set()

  function detectActiveElement () {
    const currentActiveElement = document.activeElement
    if (activeElement !== currentActiveElement) {
      const previousActiveElement = activeElement
      activeElement = currentActiveElement
      for (const callback of callbacks) {
        try {
          callback(currentActiveElement, previousActiveElement)
        } catch (error) {
          console.log(error)
        }
      }
      return true
    }
    return false
  }

  function initialize () {
    if (initialized) return
    activeElement = document.activeElement
    addEventListener('focus', detectActiveElement, true)
    addEventListener('blur', detectActiveElement, true)
    initialized = true
  }

  function finalize () {
    if (!initialized) return
    activeElement = null
    removeEventListener('focus', detectActiveElement, true)
    removeEventListener('blur', detectActiveElement, true)
    initialized = false
  }

  return [function (callback) {
    initialize()
    callbacks.add(callback)
  }, function (callback) {
    callbacks.delete(callback)
    if (callbacks.size === 0) {
      finalize()
    }
  }]
})()
